import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//
// Services
//
import { RtiMessageBusService } from '../service/common/rti-MessageBusService';
//
// Directives
//
import { RtiActionClickDirective } from './common/rti-action-click.directive';
import { RtiCarouselItemDirective } from './common/rti-carousel-item.directive';
import { RtiAnchorDirective } from './common/rti-anchor.directive';
//
// Directives
//
const RTI_DIRECTIVE = [
  RtiActionClickDirective,
  RtiCarouselItemDirective,
  RtiAnchorDirective
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: RTI_DIRECTIVE,
  exports: RTI_DIRECTIVE,
  providers: [
    RtiMessageBusService
  ]
})

export class RtiDirectiveModule {
}
